import type { HttpService } from '@storebrand-digital/bank-foundation-http-service';

import ApiRoutePath from '../constants/apiRoutePath';
import type {
  CalculateLoanDownPaymentPayload,
  ChangeMortgageInterestOnlyPayload,
  ChangeMortgagePaymentAccountPayload,
  ChangeMortgagePaymentAmountPayload,
  ChangeMortgagePaymentDatePayload,
  ChangeMortgageRepaymentPeriodPayload,
  ListMortgageAccountsResponse,
  ListPaymentAccountsResponse,
  LoanDownPaymentResponse,
} from '../types';

export default class EditMortgageService {
  #httpService: HttpService;

  constructor(httpService: HttpService) {
    this.#httpService = httpService;
  }

  listMortgageAccounts = async () =>
    this.#httpService
      .get<ListMortgageAccountsResponse>(
        ApiRoutePath.LIST_MORTGAGE_LOAN_ACCOUNTS
      )
      .then(({ data }) => data);

  listPaymentAccounts = async () =>
    this.#httpService.get<ListPaymentAccountsResponse>(
      ApiRoutePath.LIST_PAYMENT_ACCOUNTS
    );

  getCurrentInterestRate = async () =>
    this.#httpService
      .get<string>(ApiRoutePath.GET_CURRENT_INTEREST_RATE)
      .then(({ data }) => data);

  postCalculateLoanDownPayment = async (
    payload: CalculateLoanDownPaymentPayload
  ) =>
    this.#httpService
      .post<
        LoanDownPaymentResponse,
        CalculateLoanDownPaymentPayload
      >(ApiRoutePath.POST_CALCULATE_LOAN_DOWNPAYMENT, payload)
      .then(({ data }) => data);

  postChangeMortgagePaymentAccount = async (
    payload: ChangeMortgagePaymentAccountPayload
  ) =>
    this.#httpService.post(ApiRoutePath.POST_CHANGE_PAYMENT_ACCOUNT, payload);

  postChangeMortgagePaymentDate = async (
    payload: ChangeMortgagePaymentDatePayload
  ) => this.#httpService.post(ApiRoutePath.POST_CHANGE_PAYMENT_DATE, payload);

  postChangeMortgageRepaymentPeriod = async (
    payload: ChangeMortgageRepaymentPeriodPayload
  ) =>
    this.#httpService.post(ApiRoutePath.POST_CHANGE_REPAYMENT_PERIOD, payload);

  postChangeToInterestOnly = async (
    payload: ChangeMortgageInterestOnlyPayload
  ) =>
    this.#httpService.post(ApiRoutePath.POST_CHANGE_TO_INTEREST_ONLY, payload);

  postChangeMortgagePaymentAmount = async (
    payload: ChangeMortgagePaymentAmountPayload
  ) => this.#httpService.post(ApiRoutePath.POST_CHANGE_PAYMENT_AMOUNT, payload);
}
